const {Component} = require("react");
const Quill = require("react-quill");
const Field = require("components/forms/Field");
const {pluckKeysExcept} = require("helpers/object");

class RichTextarea extends Component {

	constructor(props) {
		super(props);

		this.state = {
			value: props.value || props.defaultValue || ""
		};
	}

	get fieldProps() {
		return pluckKeysExcept(this.props, ["className", "tag", "onChange", "value", "defaultValue", "name"])
	}

	get className() {
		let classList = [];

		if (typeof this.props.className === "string") {
			classList.push(this.props.className);
		}

		classList.push("quill-editor");

		return classList.join(" ");
	}

	get modules() {
		return {
			toolbar: [
				["bold", "italic", "underline", "strike", "link"],
				[{list: "ordered"}, {list: "bullet"}],
				["clean"]
			]
		};
	}

	onChange = (value) => {
		this.setState({value}, () => {
			if (typeof this.props.onChange === "function") {
				this.props.onChange({target: {value}});
			}
		});

		if (typeof this.props.afterChange == "function") {
			if (this.props.defaultValue !== this.state.value) {
				this.props.afterChange();
			}
		}
	};

	render() {
		return (
			<Field tag="div" className={this.className} {...this.fieldProps}>
				<input type="hidden" name={this.props.name} value={this.state.value}/>
				<Quill value={this.state.value} onChange={this.onChange} modules={this.modules}/>
			</Field>
		);
	}

}

module.exports = RichTextarea;



// WEBPACK FOOTER //
// ./resources/js/components/forms/RichTextarea.js